import { pollingConfig } from "../config/debounce.intervals";

export const activityStore = {
    namespaced: true,
    state: () => ({
        lastActivityAt: Date.now(),
        idleThresholdMs: pollingConfig.idleThresholdMs,
        listenersRegistered: false,
    }),
    mutations: {
        touchActivity(state) {
            state.lastActivityAt = Date.now();
        },
        setListenersRegistered(state, value) {
            state.listenersRegistered = value;
        },
    },
};
